._illustration_brstp_1 {
  max-width: 100%; }
